module.exports = __webpack_public_path__ + "static/media/shape-phone.0dbd4567.png";